import { useTranslations } from '@npco/common-utils-translations'
import { Flex, TickIcon } from '@npco/zeller-design-system'

import { savingsAccountBannerTranslations } from '../SavingsAccountBanner.i18n'
import * as styled from '../SavingsAccountBanner.styled'

export const Checklist = () => {
  const t = useTranslations(savingsAccountBannerTranslations)

  return (
    <Flex
      gap="16px"
      pb="24px"
      pl="6px"
      flexDirection={{ _: 'column', MD: 'row' }}
    >
      <Flex gap="9px">
        <TickIcon />
        <styled.BannerListItemText>{t('list1')}</styled.BannerListItemText>
      </Flex>
      <Flex gap="9px">
        <TickIcon />
        <styled.BannerListItemText>{t('list2')}</styled.BannerListItemText>
      </Flex>
      <Flex gap="9px">
        <TickIcon />
        <styled.BannerListItemText>{t('list3')}</styled.BannerListItemText>
      </Flex>
    </Flex>
  )
}
